import createReducer from 'common/reducerBase';
import QueueRecord from '../data/QueueRecord';

export default {
  queueView: createReducer(QueueRecord(), {}),
};
